import { debug, extractRequestMetadata, makeCookieSessionStorage, makeSrvLgApiConnector, } from "@lg-plus/landing-modules";
export async function selectOfferHandler(req, res) {
    if (req.method !== "POST") {
        res.status(405).end(); // Method Not Allowed
        return;
    }
    debug("Offer selected:", req.body);
    const { offerKey, payload } = req.body;
    if (!offerKey) {
        res.status(400).end();
        return;
    }
    const sessionStorage = makeCookieSessionStorage(req, res);
    const connector = makeSrvLgApiConnector();
    const apiCallResult = await connector.triggerOfferSelected(offerKey, payload ?? {}, {
        sessionToken: sessionStorage.load() || "",
        request: extractRequestMetadata(req),
    });
    if (apiCallResult.sessionToken) {
        sessionStorage.store(apiCallResult.sessionToken);
    }
    res.status(200).json(apiCallResult);
    debug("API response:", apiCallResult);
}
